import { useState, useEffect, useCallback } from 'react';
import { fetchTimezoneSettings, formatDateWithTimezoneSync, clearTimezoneSettingsCache } from '../utils/dateUtils';

export const useTimezone = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadSettings = async () => {
      try {
        setIsLoading(true);
        setError(null);
        clearTimezoneSettingsCache();
        await fetchTimezoneSettings();
        if (mounted) {
          setIsLoading(false);
        }
      } catch (err) {
        console.error('Failed to load timezone settings:', err);
        if (mounted) {
          setError(err);
          setIsLoading(false);
        }
      }
    };

    loadSettings();

    return () => {
      mounted = false;
    };
  }, []);

  /**
   * Format a date with timezone
   * @param {string|Date} dateInput - ISO date string or Date object
   * @param {Object} options - Formatting options
   * @returns {string} Formatted date string
   */
  const formatDate = useCallback((dateInput, options = {}) => {
    return formatDateWithTimezoneSync(dateInput, options);
  }, []);

  return {
    formatDate,
    isLoading,
    error,
  };
};

